module.exports = __webpack_public_path__ + "img/whatsapp.f0af8ed.svg";